import { render, staticRenderFns } from "./StudentTask.vue?vue&type=template&id=3fd79452&scoped=true&"
import script from "./StudentTask.vue?vue&type=script&lang=js&"
export * from "./StudentTask.vue?vue&type=script&lang=js&"
import style0 from "./StudentTask.vue?vue&type=style&index=0&id=3fd79452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd79452",
  null
  
)

export default component.exports